import { GridIconSVG, ListIconSVG } from "@/src/ui/AllSVG"

interface ViewToggleProps {
  view: 'grid' | 'list'
  onChange: (view: 'grid' | 'list') => void
  totalPosts: number
}


export default function ViewToggle({ view, onChange, totalPosts }: ViewToggleProps) {
  return (
    <div className="flex items-center justify-end gap-4">
      {/* <p className="text-sm text-body-color/50 font-light">
        <span className="font-medium text-body-color">{totalPosts}</span> articles
      </p> */}

      <div className="flex items-center border border-muted-color rounded-xl overflow-hidden">
        <button
          onClick={() => onChange('grid')}
          aria-label="Grid view"
          className={`flex items-center justify-center w-10 h-10 transition-colors duration-200 ${
            view === 'grid'
              ? 'bg-body-color text-white'
              : 'bg-white text-body-color/50 hover:text-body-color hover:bg-secondary-background-color'
          }`}
        >
          <GridIconSVG />
        </button>
        <div className="w-px h-5 bg-muted-color" />
        <button
          onClick={() => onChange('list')}
          aria-label="List view"
          className={`flex items-center justify-center w-10 h-10 transition-colors duration-200 ${
            view === 'list'
              ? 'bg-body-color text-white'
              : 'bg-white text-body-color/50 hover:text-body-color hover:bg-secondary-background-color'
          }`}
        >
          <ListIconSVG />
        </button>
      </div>
    </div>
  )
}
